// ** Third Party Components
import loadable from "@loadable/component";

// ** Components
const ActionsComponent = loadable(
	() => import("../ActionsComponent/ActionsComponent"),
	{
		ssr: false,
	},
);

// #####################################################

const ActionSection = ({
	actionItems,
	isActionMenuVisible,
	setActionMenuVisibility,
}) => {
	// #####################################################

	if (actionItems && actionItems.length > 0) {
		return (
			<ActionsComponent
				actionItems={actionItems}
				isActionMenuVisible={isActionMenuVisible}
				setActionMenuVisibility={setActionMenuVisibility}
			/>
		);
	}
	return null;
};

// #####################################################

export default ActionSection;

// #####################################################
